import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import Text from 'components/Text';
import VisuallyHidden from 'components/VisuallyHidden';
function getTrendKey(value) {
  if (value > 0) return 'positive';else if (value < 0) return 'negative';else return 'neutral';
}
function getIconName(trendKey) {
  if (trendKey === 'negative') return 'nav-down';else if (trendKey === 'positive') return 'nav-up';else return 'dot';
}
function TrendIndicator(props) {
  var value = props.value,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var trendKey = getTrendKey(value);
  var readableLabel = "".concat(Math.abs(value), "%");
  var isNeutral = trendKey === 'neutral';
  return /*#__PURE__*/React.createElement(Text, _extends({
    display: "inline-block",
    dimmed: isNeutral,
    textColor: isNeutral ? undefined : trendKey
  }, otherProps), /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    name: getIconName(trendKey),
    scale: 0.8
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, readableLabel), /*#__PURE__*/React.createElement(VisuallyHidden, null, t("analytics_trend_".concat(trendKey), {
    percent: readableLabel
  })));
}
export default TrendIndicator;